module.exports = __webpack_public_path__ + "static/media/t1.112b00a6.png";